module.exports = __webpack_public_path__ + "static/media/whatsapp-topo.09912456.svg";